export default {
	TEXT: 'text',
	FLOAT: 'float',
	NUMBER: 'number',
	DATE: 'date',
	CUSTOM: 'custom',
};
